import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface IndicesPropertyCategoryItemObject {
  id: number;
  titleEn: string;
  titleAr: string;
  slug: string;
  disablePriceAreas: boolean;
  disableVolumeAreas: boolean;
  volume_index_ticker: boolean;
  price_index_view_active: boolean;
  volume_index_view_active: boolean;
  ppm_view_active: boolean;
  no_of_deals_view_active: boolean;
  isActive: boolean;
}

export type IndicesPropertyCategoryViewFlag =
  | 'price_index_view_active'
  | 'volume_index_view_active'
  | 'ppm_view_active'
  | 'no_of_deals_view_active';

export interface IndicesPropertyCategoriesListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  items: Array<IndicesPropertyCategoryItemObject>;
  errors: unknown;
}

@Module
export default class IndicesPropertyCategoriesModule
  extends VuexModule
  implements IndicesPropertyCategoriesListInfo
{
  items = [] as Array<IndicesPropertyCategoryItemObject>;
  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  get indicesPropertyCategoryList(): Array<IndicesPropertyCategoryItemObject> {
    return this.items;
  }

  get indicesPropertyCategoryListCount(): number {
    return this.totalItems;
  }

  @Mutation
  [Mutations.SET_INDICES_PROPERTY_CATEGORIES](data) {
    this.items = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_INDICES_PROPERTY_CATEGORY_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.RESET_INDICES_PROPERTY_CATEGORIES_LIST]() {
    this.items = [] as Array<IndicesPropertyCategoryItemObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Action
  [Actions.CREATE_INDICES_PROPERTY_CATEGORY](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/indices/property-categories', data)
      .then(() => {
        this.context.commit(Mutations.RESET_INDICES_PROPERTY_CATEGORIES_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_INDICES_PROPERTY_CATEGORY]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/indices/property-categories', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_INDICES_PROPERTY_CATEGORIES_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_INDICES_PROPERTY_CATEGORY_VIEW_FLAGS]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update(
      '/indices/property-categories',
      `${id}/view-flags`,
      data
    ).catch(({ response }) => {
      this.context.commit(Mutations.SET_ERROR, {
        [response.statusText]: [response.data.message],
      });
    });
  }

  @Action
  [Actions.DELETE_INDICES_PROPERTY_CATEGORY](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/indices/property-categories', id)
      .then(() => {
        this.context.commit(Mutations.RESET_INDICES_PROPERTY_CATEGORIES_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_INDICES_PROPERTY_CATEGORY_CURRENT_PAGE](val) {
    this.context.commit(
      Mutations.SET_INDICES_PROPERTY_CATEGORY_CURRENT_PAGE,
      val
    );
  }

  @Action
  [Actions.GET_INDICES_PROPERTY_CATEGORY](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/indices/property-categories', id);
  }

  @Action
  [Actions.GET_INDICES_PROPERTY_CATEGORIES]() {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/indices/property-categories/list', {
      params: { page: this.currentPage },
    })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_INDICES_PROPERTY_CATEGORIES, data);
      })
      .catch(({ response }) => {
        console.error(response);
      });
  }

  @Action
  [Actions.RESET_INDICES_PROPERTY_CATEGORY_STORE]() {
    this.context.commit(Mutations.RESET_INDICES_PROPERTY_CATEGORIES_LIST);
  }
}
